import { Box } from "@mui/system";
import { palette } from "../../themes/theme";
import moveIcon from "../../assets/icons/icon_move.svg";
import toolWarpIcon from "../../assets/icons/icon_tool_wrap.svg";
import addImageIcon from "../../assets/icons/icon_add_image.svg";
import addTextIcon from "../../assets/icons/icon_tool_text.svg";
import rectangleIcon from "../../assets/icons/icon_rectangle.svg";
import { IconButton, styled } from "@mui/material";
import { useContext } from "react";
import { MapToolboxContext } from "../../context/mapToolbox/mapToolbox.provider";
import { ScrollContainer } from "./mapStyledComponents";

const StyledIconButton = styled(IconButton)((props) => ({
  background: props.active ? palette.primary.main : palette.background.light,
  border: `1px solid ${palette.secondary.main}`,
  borderRadius: "5px",
  width: "50px",
  height: "50px",
  boxShadow: props.active
    ? "0px 2px 8px rgba(0, 0, 0, 0.2)"
    : "none",
  "& img": {
    filter: props.active
      ? `brightness(120%) saturate(150%) contrast(90%) sepia(15%)`
      : "brightness(0) saturate(100%) invert(12%) sepia(24%) saturate(4447%) hue-rotate(196deg) brightness(96%) contrast(96%);", // for example, if you want to apply CSS filters
  },
  ":hover": {
    background: palette.primary.hover,
  },
}));

const MapEditingTools = ({
  mapRef,
  // showPolygonStyleSettings,
  setPolygonSelected,
  createPolygon,
  setMapToolBarOptionFlags,
  resetActiveId,
  resetMapToolbarOptionFlags,
  setShapeSettings,
  resetAllOnceChanged,
}) => {
  const { activeId, setActiveId } = useContext(MapToolboxContext);

  const handleArrowClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "arrow") {
      resetActiveId();
      return;
    }
    mapRef.getCanvas().style.cursor = "default";
    setActiveId("arrow");
  };

  const handleToolWrapClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "tool-wrap-polygon") {
      resetActiveId();
      return;
    }
    setMapToolBarOptionFlags((d) => ({ ...d, polygon: true }));
    setActiveId("tool-wrap-polygon");
    setPolygonSelected(null);
    createPolygon();
    mapRef.getCanvas().style.cursor = "crosshair";
  };

  const handleAddImageClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "add-image") {
      resetActiveId();
      return;
    }
    setMapToolBarOptionFlags((d) => ({ ...d, logoUpload: true }));
    mapRef.getCanvas().style.cursor = "crosshair";
    setActiveId("add-image");
  };

  const handleAddTextClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "add-text") {
      resetActiveId();
      return;
    }
    mapRef.getCanvas().style.cursor = "crosshair";
    setMapToolBarOptionFlags((d) => ({ ...d, textSetting: true }));
    setActiveId("add-text");
  };

  const handleShapeClick = () => {
    resetMapToolbarOptionFlags();
    resetAllOnceChanged();
    if (activeId === "shape") {
      resetActiveId();
      return;
    }
    mapRef.getCanvas().style.cursor = "crosshair";
    setShapeSettings((previousValue) => {
      previousValue.addShapeToMapFlag = true;
      previousValue.addSelectedShapeFlag = "fa-sharp fa-solid fa-square";
      return previousValue;
    });
    setActiveId("shape");
  };

  return (
    <ScrollContainer
      variant="scrollable"
      value={0}
      scrollButtons
      allowScrollButtonsMobile
    >
      <Box sx={{ display: "flex", gap: "12px" }}>
        <StyledIconButton
          active={activeId === "arrow"}
          onClick={handleArrowClick}
          sx={{ border: `2px solid ${palette.primary.main}` }}
        >
          <img src={moveIcon} alt="arrow" />
        </StyledIconButton>
        <StyledIconButton
          active={activeId === "tool-wrap-polygon"}
          onClick={handleToolWrapClick}
          sx={{ border: `2px solid ${palette.primary.main}` }}
        >
          <img src={toolWarpIcon} alt="tool-wrap-polygon" />
        </StyledIconButton>
        <StyledIconButton
          active={activeId === "add-image"}
          onClick={handleAddImageClick}
          sx={{ border: `2px solid ${palette.primary.main}` }}
        >
          <img src={addImageIcon} alt="add-image" />
        </StyledIconButton>
        <StyledIconButton
          active={activeId === "add-text"}
          onClick={handleAddTextClick}
          sx={{ border: `2px solid ${palette.primary.main}` }}
        >
          <img src={addTextIcon} alt="add-text" />
        </StyledIconButton>
        <StyledIconButton
          active={activeId === "shape"}
          onClick={handleShapeClick}
          sx={{ border: `2px solid ${palette.primary.main}` }}
        >
          <img src={rectangleIcon} alt="shape" />
        </StyledIconButton>
      </Box>
    </ScrollContainer>
  );
};
export default MapEditingTools;
